import { render, staticRenderFns } from "./B2BOrdersPage.vue?vue&type=template&id=9669d19e"
import script from "./B2BOrdersPage.vue?vue&type=script&lang=js"
export * from "./B2BOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./B2BOrdersPage.vue?vue&type=style&index=0&id=9669d19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports